export default __webpack_public_path__ + "static/media/dash_2.3045526a.png";